// KPI P4 dashboard views — pure helpers. The widget and template registry comes from the server
// (getKpiDashboardViews), so the dashboard and its exports can never disagree on what a view shows.
import { clearDashboardFilters, patchDashboardParams } from "./kpiDashboardUtils"

export const VIEW_PARAM = "view"

// The active view for ?view=<id>: a template or a saved view; null = the full dashboard.
export const resolveView = ({ viewId, templates = [], views = [] }) => {
  if (!viewId) return null
  return templates.find((t) => t.id === viewId) ?? views.find((v) => v.id === viewId) ?? null
}

export const widgetVisible = ({ view, id }) => !view || (view.widgets ?? []).includes(id)

// Choosing a view replaces the filters with the view's own (range kept unless the view sets one).
export const applyViewParams = (prev, view) => {
  let next = clearDashboardFilters(prev)
  if (!view) {
    next.delete(VIEW_PARAM)
    return next
  }
  const state = view.state ?? {}
  const filters = state.filters ?? {}
  next = patchDashboardParams(next, {
    ...(state.rangeMonths ? { rangeMonths: state.rangeMonths } : {}),
    scenarioType: filters.scenarioType ?? [],
    department: filters.department ?? [],
    setupType: filters.setupType ?? [],
    mode: filters.mode ?? "all",
  })
  next.set(VIEW_PARAM, view.id)
  return next
}

// What "Save view" stores: the current range and filters, the chosen widgets and framework.
export const viewPayload = ({ name, widgets, rangeMonths, filters, frameworkId = null, templateId = null }) => {
  const clean = {}
  for (const key of ["scenarioType", "department", "setupType"]) if (filters?.[key]?.length) clean[key] = [...filters[key]]
  if (filters?.mode) clean.mode = filters.mode
  return { name: name.trim(), widgets, state: { rangeMonths, filters: clean }, frameworkId, templateId }
}

export const downloadBase64File = ({ fileName, mimeType, contentBase64 }) => {
  const bytes = Uint8Array.from(atob(contentBase64), (c) => c.charCodeAt(0))
  const url = URL.createObjectURL(new Blob([bytes], { type: mimeType }))
  const a = document.createElement("a")
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
